<form (ngSubmit)="onSubmit()" [formGroup]="form">

  <evland-modal-container (onClose)="onClose()" [title]="modalTitle()">

    <div class="row">

      <div class="col-12 col-md-6">
        <evland-form-field i18n-label label="Пароль">
          <input evlandInput formControlName="password" type="password" />
        </evland-form-field>
      </div>

      <div class="col-12 col-md-6">
        <evland-form-field i18n-label label="Підтвердження пароля">
          <input evlandInput formControlName="confirm_password" type="password" />
        </evland-form-field>
      </div>

      <p class="subtitle">{{ passwordHint }}</p>

    </div>

    <evland-submit-button [disabled]="form.invalid" [isLoading]="isSubmitting()" class="d-block mb-3" i18n>Зберегти</evland-submit-button>


  </evland-modal-container>

</form>
